import React, { useEffect, useRef, useState } from 'react';

const ScrollingText = ({
  text,
  additionalDivClass,
  additionalSpanClass,
  onClick,
}) => {
  const containerRef = useRef(document.createElement('div'));
  const scrollRef = useRef(document.createElement('span'));
  const [translateX, setTranslateX] = useState(0);
  const [transition, setTransition] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [scrollWidth, setScrollWidth] = useState(0);
  const [leftHovered, setLeftHovered] = useState(false);
  const [rightHovered, setRightHovered] = useState(false);

  useEffect(() => {
    setContainerWidth(containerRef.current.offsetWidth);
    setScrollWidth(scrollRef.current.offsetWidth);
    if(containerRef.current.offsetWidth === scrollRef.current.offsetWidth) {
      setTranslateX(0);
    }

    const intervalRight = setInterval( () => {
      if (rightHovered && scrollWidth > containerWidth && (scrollWidth + translateX) > containerWidth) {
        setTranslateX(translateX - 25);
        setTransition(10);
      }
    }, 75)

    let intervalLeft = setInterval( () =>  {
      if(leftHovered && translateX < 0) {
        setTranslateX(translateX + 25);
        setTransition(10);
      }
    }, 75);

    if(!leftHovered) {
      clearInterval(intervalLeft)
    }
    if(!rightHovered) {
      clearInterval(intervalRight)
    }

    return () => {
      clearInterval(intervalLeft)
      clearInterval(intervalRight)
    }
  }, [text, containerRef.current.offsetWidth, scrollRef.current.offsetWidth, leftHovered, rightHovered, translateX]);

  return (
    <>
      <div
        ref={containerRef}
        className={`scrolling-text ${additionalDivClass} 
        ${scrollWidth > containerWidth ? 'overflow-fade' : ''}`}
        style={{
          padding: "10px 0px",
          borderBottom: "1px solid rgba(0,0,0,.1)",
          borderTop: "1px solid rgba(0,0,0,.1)",
          marginBottom: "15px",
        }}
      >
        <span
          onClick={onClick}
          ref={scrollRef}
          className={additionalSpanClass}
          style={{
            transform: `translateX(${translateX}px)`,
            transition: `${transition}ms`,
            position: 'relative',
            float: 'left',
            minWidth: "100%",
            display: "flex"
          }}
        >
          {text}
        </span>
        <div
          onMouseEnter={() => setRightHovered(true)}
          onMouseLeave={() => setRightHovered(false)}
          style={{
            width: "2.5%",
            position: "absolute",
            right: 0,
            top: 0,
            height: "100%",
            background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            opacity: (scrollWidth > containerWidth && (scrollWidth + translateX) > containerWidth) ? 1: 0
          }}/>
        <div
          onMouseEnter={() => setLeftHovered(true)}
          onMouseLeave={() => setLeftHovered(false)}
          style={{
            width: "2.5%",
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            background: "linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)",
            opacity: translateX < 0 ? 1: 0
          }}
        />
    </div>
    </>
  );
};

export default ScrollingText;